import store from "@/store";
import { readCookie, eraseCookie } from "@/assets/js/appFunc";
import Apps from "./views/Apps/Apps.vue";

export const EXCLUDE_DIALOG_TO_PAGE = [
    { from: ["/integrations/systemApi"], to: ["/integrations/exposedCredentials", "/integrations/externalApi"] },
    { from: ["/integrations/exposedCredentials"], to: ["/integrations/systemApi", "/integrations/externalApi"] },
    { from: ["/integrations", "/integrations/externalApi"], to: ["/integrations/systemApi", "/integrations/exposedCredentials"] },
    { from: ["/dataStore/dataTables"], to: [""] }
];

export const NO_DIAGRAM_CHECK = ["reports", "search", "perspectiveBuilder"];

export const PAGE_LIST = ["AddToArchive", "appSpecificGroups", "permissions", "smartContractList", "dataModelMaster", "dataModel", "catalogs",
    "userInterfaces", "apis", "mainApis", "consumed", "internalApis", "expose",
    "diagrams", "process", "reports", "statistics", "documents", "administration", "ProcessList",
    "search", "perspectiveBuilder", "catalogs"];

const extraRoutes = [
    {
        path: "/components",
        name: "components",
        component: () => import(/* webpackChunkName: "components" */ "./views/Components/Components.vue")
    },
    {
        path: "/wallet",
        name: "wallet",
        component: () => import(/* webpackChunkName: "wallet" */ "./views/Wallet/Wallet.vue")
    }
];

export const ROUTER_ROUTES = [
    // ROUTER : General Routes

    {
        path: "/",
        name: "dashboard",
        redirect: () => (localStorage.getItem("localIsSmallScreen") ? "/tasks" : "/mydashboard"),
        component: () => import(/* webpackChunkName: "appDashboard" */ "./views/Dashboard/DashboardRouter.vue"),
        beforeEnter: (to, from, next) => {
            if (store().getters["userProfile/getUserId"]) {
                next(true);
            } else {
                store().dispatch("tasks/getUserDetails").then(
                    () => next(true),
                    () => next(true)
                );
            }
        },
        children: [
            {
                path: "/mydashboard",
                name: "mydashboard",
                component: () => import(/* webpackChunkName: "appDashboard" */ "./views/Dashboard/Dashboard.vue"),
                beforeEnter: (to, from, next) => {
                    const { query } = to;
                    store().commit("dashboard/setRemoveRouteQuery", false);

                    if (query && Object.keys(query).length) {
                        store().dispatch("dashboard/getDashboardCustomization", { type: "MY_DASHBOARD" }).then(
                            data => {
                                const dashboardItems = JSON.parse(data.data.settings);
                                dashboardItems.forEach(item => {
                                    if (item.name === "tasks") {
                                        const taskNotVisible = !item.visible || item.childOptions.find(el => el.name === "tasklist" && !el.visible);
                                        if (taskNotVisible) {
                                            store().commit("dashboard/setRemoveRouteQuery", true);
                                        }
                                    }
                                });
                                next();
                            },
                            () => next()
                        );
                    } else {
                        next();
                    }
                }
            },
            {
                path: "/myteamsdashboard",
                name: "myteamsdashboard",
                component: () => import(/* webpackChunkName: "appDashboard" */ "./views/Dashboard/Dashboard.vue"),
                beforeEnter: (to, from, next) => {
                    const userIsManager = store().getters["userProfile/getUserIsManager"];
                    if (userIsManager) {
                        const { query } = to;
                        store().commit("dashboard/setRemoveRouteQuery", false);

                        if (query?.groupId && Object.keys(query).length > 1) {
                            const payload = {
                                type: "TEAM_DASHBOARD",
                                groupId: query.groupId
                            };
                            store().dispatch("dashboard/getDashboardCustomization", payload).then(
                                data => {
                                    const dashboardItems = JSON.parse(data.data.settings);
                                    dashboardItems.forEach(item => {
                                        if (item.name === "tasks") {
                                            const taskNotVisible = !item.visible || item.childOptions.find(el => el.name === "tasklist" && !el.visible);
                                            if (taskNotVisible) {
                                                store().commit("dashboard/setRemoveRouteQuery", true);
                                            }
                                        }
                                    });
                                    next();
                                },
                                () => next()
                            );
                        } else {
                            next();
                        }
                    } else {
                        next("/");
                    }
                }
            }
        ]
    },
    {
        path: "/dataStore",
        redirect: "/dataStore/dataTables",
        component: { render: (h) => h("router-view") },
        children: [
            {
                path: "dataTables/:tableCode?",
                name: "dataStore",
                meta: {
                    breadcrumbs: {
                        type: "app",
                        hybrid: true,
                        path() {
                            const entity = store().getters["dataStore/getSelectedEntity"];
                            if (entity.name) {
                                return [
                                    { label: "generic.bcGlobalFeatures", link: false },
                                    { label: "generic.bcEntities", link: "/dataStore/dataTables" },
                                    { key: "selectedEntity", link: false, list: "dataStore" }
                                ];
                            }

                            return [
                                { label: "generic.bcGlobalFeatures", link: false }
                            ];
                        }
                    }
                },
                beforeEnter: (to, from, next) => {
                    const systemPermissions = store().getters["apps/getUserSystemPermissions"];
                    if (systemPermissions && systemPermissions.hasOwnProperty("D") && systemPermissions.D.hasOwnProperty("g")) {
                        next(true);
                    } else {
                        next({ path: "/accessDenied" });
                    }
                },
                component: () => import(/* webpackChunkName: "DataStore" */ "./views/GlobalFeatures/GlobalFeaturesNew.vue")
            },
            {
                path: "dataTablesLegacy/:tableId?",
                name: "dataStoreLegacy",
                meta: {
                    breadcrumbs: {
                        type: "app",
                        path() {
                            const path = [
                                { label: "generic.bcGlobalFeatures", link: false }
                            ];
                            const entity = store().getters["GDM/getEntitySelected"];

                            if (entity) {
                                path.push({ label: "generic.bcEntities", link: "/dataStore/dataTablesLegacy" });
                            }

                            return path;
                        }
                    }
                },
                component: () => import(/* webpackChunkName: "DataStoreLegacy" */ "./views/GlobalFeatures/GlobalFeatures.vue")
            },
            {
                path: "connectionsLegacy",
                name: "globalIntegration",
                meta: {
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcGlobalFeatures", link: false }
                        ]
                    }
                },
                component: () => import(/* webpackChunkName: "GlobalIntegration" */ "./views/GlobalFeatures/GlobalIntegration.vue")
            }
        ]
    },
    {
        path: "/applications",
        component: () => import(/* webpackChunkName: "Apps" */ "./views/Apps/Apps.vue"),
        children: [
            {
                path: "",
                name: "appsMainPage",
                component: () => import(/* webpackChunkName: "appsMainPage" */ "@/components/apps/appsMainPage/appsMainPage.vue")
            },
            {
                path: "YourApplications",
                name: "YourApplications",
                component: () => import(/* webpackChunkName: "appsYourApps" */ "@/components/apps/applicationsPage/applicationsPage.vue")
            },
            {
                path: "AddToArchive",
                name: "AddToArchive",
                component: () => import(/* webpackChunkName: "AddToArchive" */ "@/components/apps/addToArchive/addToArchive.vue")
            },
            {
                path: "SharedApplications",
                name: "SharedApplications",
                component: () => import(/* webpackChunkName: "appsSharedApps" */ "@/components/apps/sharedApplications/sharedApplications.vue")
            },
            {
                path: "ArchivedApplications",
                name: "ArchivedApplications",
                component: () => import(/* webpackChunkName: "appsArchivedApps" */ "@/components/apps/archivedApplications/archivedApplications.vue")
            },
            // ROUTER : Application Routes
            {
                path: ":applicationId",
                name: "appIdInterfaces",
                redirect: to => `/applications/${to.params.applicationId}/processes`,
                component: () => import(/* webpackChunkName: "AppsModules" */ "./views/Apps/appsModules.vue"),
                children: [
                    {
                        path: "processes",
                        name: "processes",
                        meta: {
                            permissionCode: "DI"
                        },
                        props: {
                            permissionCode: "DI"
                        },
                        component: () => import(/* webpackChunkName: "processes" */ "./views/Processes/ProcessListParent.vue"),
                        children: [
                            {
                                path: "",
                                name: "ProcessList",
                                meta: {
                                    permissionCode: "DI",
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcProcesses", link: "xxx" }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: "DI"
                                },
                                component: () => import(/* webpackChunkName: "ProcessList" */ "./views/Processes/ProcessList.vue")
                            },
                            {
                                path: ":processId",
                                name: "process",
                                meta: {
                                    permissionCode: "DI",
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcProcesses", link: "/processes" },
                                            { key: "currentProcess", link: false, list: "processes" }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: "DI"
                                },

                                beforeEnter: (to, from, next) => {
                                    store().dispatch("apps/actDiagramExternalPlugins").then(
                                        () => next(true),
                                        () => next(true)
                                    );
                                },
                                component: () => import(/* webpackChunkName: "process" */ "./views/Syncfusion/Diagram.vue")
                            },
                            {
                                path: "statusReport",
                                name: "StatusReport",
                                meta: {
                                    permissionCode: "DI",
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcProcesses", link: "/processes" },
                                            { label: "generic.bcArchiveProcess", link: false }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: "DI"
                                },
                                component: () => import(/* webpackChunkName: "StatusReport" */ "./views/Processes/StatusReport/StatusReport.vue")
                            }
                        ]
                    },
                    {
                        path: "diagrams",
                        name: "diagrams",
                        meta: {
                            permissionCode: "DI",
                            breadcrumbs: {
                                type: "edit",
                                path: [
                                    { label: "generic.bcApplications", link: "/applications" },
                                    { key: "currentAppName", link: false },
                                    { label: "generic.bcProcesses", link: "/processes" },
                                    { key: "currentProcess", link: false, list: "processes" }
                                ]
                            }
                        },
                        props: {
                            permissionCode: "DI"
                        },
                        component: () => import(/* webpackChunkName: "diagrams" */ "./views/Diagrams/Diagrams.vue")
                    },
                    {
                        path: "userInterfaces/:userInterfaceId?",
                        name: "userInterfaces",
                        alias: "/applications/:applicationId/fragments/:userInterfaceId?",
                        meta: {
                            permissionCode: "IB",
                            breadcrumbs: {
                                type: "edit",
                                path: [
                                    { label: "generic.bcApplications", link: "/applications" },
                                    { key: "currentAppName", link: false },
                                    { label: "generic.bcInterfaceBuilder", link: "/userInterfaces" },
                                    { key: "currentInterface", link: false, list: "interfaces" }
                                ]
                            }
                        },
                        props: {
                            permissionCode: "IB"
                        },
                        beforeEnter: (to, from, next) => {
                            const { params, path } = to;
                            if (params.userInterfaceId) {
                                store().dispatch("components/getLatestAppInterfaces").then(
                                    data => {
                                        const selectedInterface = data.find(item => item.id === params.userInterfaceId);
                                        if (selectedInterface) {
                                            next();
                                        } else {
                                            next(`/applications/${params.applicationId}/${path.includes("userInterfaces") ? "userInterfaces" : "fragments"}`);
                                        }
                                    },
                                    () => next()
                                );
                            } else {
                                next();
                            }
                        },
                        component: () => import(/* webpackChunkName: "userInterfaces" */ "./views/UserInterfaces/UserInterfacesStart.vue")
                    },
                    {
                        path: "documentTemplates/:documentId?",
                        name: "documents",
                        meta: {
                            permissionCode: "DB",
                            breadcrumbs: {
                                type: "edit",
                                path: [
                                    { label: "generic.bcApplications", link: "/applications" },
                                    { key: "currentAppName", link: false },
                                    { label: "generic.bcDocumentBuilder", link: "/documentTemplates" },
                                    { key: "currentDocument", link: false, list: "documents" }
                                ]
                            }
                        },
                        props: {
                            permissionCode: "DB"
                        },
                        component: () => import(/* webpackChunkName: "documents" */ "./views/Documents/FroalaDocuments.vue")
                    },
                    {
                        path: "integrations",
                        name: "apis",
                        redirect: to => `/applications/${to.params.applicationId}/integrations/externalApi`,
                        meta: {
                            permissionCode: "AP"
                        },
                        props: {
                            permissionCode: "AP"
                        },
                        component: () => import(/* webpackChunkName: "apis" */ "./views/Apis/Apis.vue"),
                        children: [
                            {
                                path: "externalApi",
                                name: "consumed",
                                meta: {
                                    permissionCode: "AP",
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcAPIs", link: false }
                                        ]
                                    }
                                },
                                component: () => import(/* webpackChunkName: "consume" */ "@/components/api/consume/consumedAPI.vue")
                            },
                            {
                                path: "systemApi",
                                name: "internalApis",
                                meta: {
                                    permissionCode: "AP",
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcAPIs", link: false }
                                        ]
                                    }
                                },
                                component: () => import(/* webpackChunkName: "expose" */ "@/components/api/internal/internalAPI.vue")
                            },
                            {
                                path: "exposedCredentials",
                                name: "expose",
                                meta: {
                                    permissionCode: "AP",
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcAPIs", link: false }
                                        ]
                                    }
                                },
                                component: () => import(/* webpackChunkName: "expose" */ "@/components/api/exposed/exposedAPI.vue")
                            }
                        ]
                    },

                    {
                        path: "dataModel",
                        name: "dataModel",
                        meta: {
                            permissionCode: ["DM", "CS", "CD"],
                            breadcrumbs: {
                                type: "edit",
                                path: [
                                    { label: "generic.bcApplications", link: "/applications" },
                                    { key: "currentAppName", link: false },
                                    { label: "generic.bcDataModel", link: "xxx" }
                                ]
                            }
                        },
                        props: {
                            permissionCode: "DM"
                        },
                        component: () => import(/* webpackChunkName: "dataModel" */ "./views/DataModel/views/DataModel/DataModel.vue")
                    },
                    {
                        path: "catalogs/:catalogId?",
                        name: "catalogs",
                        meta: {
                            permissionCode: ["DM", "CS", "CD"],
                            breadcrumbs: {
                                type: "edit",
                                path: [
                                    { label: "generic.bcApplications", link: "/applications" },
                                    { key: "currentAppName", link: false },
                                    { label: "generic.bcCatalogs", link: "/catalogs" },
                                    { key: "currentCatalog", link: false, list: "catalogs" }
                                ]
                            }
                        },
                        props: {
                            permissionCode: ["CS", "CD"]
                        },
                        component: () => import(/* webpackChunkName: "catalogs" */ "@/components/Catalogs/CatalogsList/catalogsList.vue")
                    },
                    {
                        path: "customDataViews/:customDataViewId?",
                        name: "perspectiveBuilder",
                        meta: {
                            permissionCode: "PB",
                            breadcrumbs: {
                                type: "edit",
                                path: [
                                    { label: "generic.bcApplications", link: "/applications" },
                                    { key: "currentAppName", link: false },
                                    { label: "generic.bcPerspectiveBuilder", link: "/customDataViews" },
                                    { key: "currentPerspective", link: false, list: "perspectives" }
                                ]
                            }
                        },
                        props: {
                            permissionCode: "PB"
                        },
                        beforeEnter: (to, from, next) => {
                            const getDiagramExternalPlugins = () => {
                                store().dispatch("apps/actDiagramExternalPlugins").then(
                                    () => next(true),
                                    () => next(true)
                                );
                            };
                            const { customDataViewId, applicationId } = to.params;
                            if (customDataViewId) {
                                if (["createNew", "duplicate"].includes(customDataViewId)) {
                                    next(`/applications/${applicationId}/customDataViews`);
                                } else {
                                    store().dispatch("perspectiveBuilder/actGetPerspectives").then(
                                        response => {
                                            const getCurrentCustomData = (response.data || []).find(item => item.id === customDataViewId);
                                            if (getCurrentCustomData) {
                                                store().commit("perspectiveBuilder/setSelectedPerspective", getCurrentCustomData);
                                                getDiagramExternalPlugins();
                                            } else {
                                                next(`/applications/${applicationId}/customDataViews`);
                                            }
                                        },
                                        () => getDiagramExternalPlugins()
                                    )
                                        .catch(() => {
                                            next();
                                        });
                                }
                            } else {
                                getDiagramExternalPlugins();
                            }
                        },
                        component: () => import(/* webpackChunkName: "perspectiveBuilder" */ "./views/PerspectiveBuilder/PerspectiveBuilder.vue")
                    },
                    {
                        path: "dataViews",
                        name: "searchContainer",
                        component: () => import(/* webpackChunkName: "SearchContainer" */ "./views/SearchPerspectives/SearchContainer.vue"),
                        children: [
                            {
                                path: ":dataViewsId?",
                                name: "search",
                                meta: {
                                    permissionCode: "DP",
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcSearchPerspectives", link: "/dataViews" },
                                            { key: "currentSearchPerspective", link: false, list: "perspectives" }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: "DP"
                                },
                                beforeEnter: (to, from, next) => {
                                    const { params: { dataViewsId, applicationId }, query } = to;
                                    const getExtraPlugins = () => {
                                        store().dispatch("apps/actDiagramExternalPlugins").then(
                                            () => next(true),
                                            () => next(true)
                                        );
                                    };
                                    if (dataViewsId) {
                                        if (Object.keys(query).length) {
                                            const getPerspectiveList = store().dispatch("perspectiveBuilder/actGetCasePerspectives");
                                            const getSelectedPerspectiveData = store().dispatch("perspectiveBuilder/actLoadCasePerspectiveData", dataViewsId);
                                            Promise.all([getPerspectiveList, getSelectedPerspectiveData]).then(
                                                response => {
                                                    const [perspectiveList, selectedPerspectiveData] = response;
                                                    store().commit("perspectiveBuilder/setPerspectivesList", perspectiveList.data);
                                                    store().commit("perspectiveBuilder/setPerspectiveId", dataViewsId);
                                                    const { perspectiveName: name } = selectedPerspectiveData.data.setup;
                                                    store().commit("perspectiveBuilder/setSearchPerspectiveData",
                                                        { ...selectedPerspectiveData.data, name } || {});
                                                    getExtraPlugins();
                                                }
                                            )
                                                .catch(() => next(`/applications/${applicationId}/dataViews`));
                                        } else {
                                            store().dispatch("perspectiveBuilder/actGetCasePerspectives").then(
                                                responseData => {
                                                    const { data } = responseData;
                                                    const selectedItem = data.find(item => item.id === dataViewsId);
                                                    if (selectedItem) {
                                                        getExtraPlugins();
                                                    } else {
                                                        next(`/applications/${applicationId}/dataViews`);
                                                    }
                                                }
                                            )
                                                .catch(() => next(`/applications/${applicationId}/dataViews`));
                                        }
                                    } else {
                                        getExtraPlugins();
                                    }
                                },
                                component: () => import(/* webpackChunkName: "dataViews" */ "./views/SearchPerspectives/SearchPerspectives.vue")
                            },
                            {
                                path: ":dataViewsId/tasks/:taskId",
                                name: "appUserTaskDataViews",
                                alias: "/applications/:applicationId/dataViews/:dataViewsId/instances/:taskId",
                                meta: {
                                    taskType: "dataViews",
                                    permissionCode: "DP"
                                },
                                props: true,
                                component: () => import(/* webpackChunkName: "appUserTask" */ "@/pages/fabricInterface/appUserTask.vue")
                            }
                        ]
                    },
                    {
                        path: "analytics",
                        name: "analytics",
                        redirect: to => `/applications/${to.params.applicationId}/analytics/processLiveView`,
                        component: () => import(/* webpackChunkName: "analytics" */ "./views/Reports/AnalyticsContainer.vue"),
                        children: [
                            {
                                path: "processLiveView/:processAnalyticsId?",
                                name: "reports",
                                meta: {
                                    permissionCode: { parent: "RP", child: ["TI", "ST", "RT", "UC"] },
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcReports", link: false },
                                            { label: "generic.bcProcessData", link: "/analytics/processLiveView" },
                                            { key: "currentProcessData", link: false }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: "RP"
                                },
                                beforeEnter: (to, from, next) => {
                                    const { processAnalyticsId, applicationId } = to.params;
                                    const getExternalPlugins = () => {
                                        store().dispatch("apps/actDiagramExternalPlugins").then(
                                            () => next(true),
                                            () => next(true)
                                        );
                                    };
                                    if (processAnalyticsId) {
                                        const pathToRedirect = `/applications/${applicationId}/analytics/processLiveView`;
                                        store().dispatch("apps/getProcessesForReports", applicationId).then(
                                            response => {
                                                const { data } = response;
                                                const selectedItem = (data || []).find(process => process.id === processAnalyticsId);
                                                if (selectedItem) {
                                                    getExternalPlugins();
                                                } else {
                                                    next(pathToRedirect);
                                                }
                                            },
                                            () => next(pathToRedirect)
                                        );
                                    } else {
                                        if (store().getters["reports/getSelectedProcessReports"].reports.id) {
                                            store().commit("reports/setSelectedProcessReports", { process: {}, pageType: "reports" });
                                        }
                                        getExternalPlugins();
                                    }
                                },
                                component: () => import(/* webpackChunkName: "reports" */ "./views/Reports/Reports.vue")
                            },
                            {
                                path: "tasks/:taskId",
                                name: "appUserTaskAnalytics",
                                alias: "/applications/:applicationId/analytics/instances/:taskId",
                                meta: {
                                    taskType: "analytics",
                                    permissionCode: { parent: "RP", child: ["TI", "ST", "RT", "UC"] }
                                },
                                props: true,
                                component: () => import(/* webpackChunkName: "appUserTask" */ "@/pages/fabricInterface/appUserTask.vue")
                            },
                            {
                                path: "processStatistics/:processAnalyticsId?",
                                name: "statistics",
                                meta: {
                                    permissionCode: { parent: "RP", child: ["TI", "ST"] },
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcReports", link: false },
                                            { label: "generic.bcStatistics", link: "/analytics/processStatistics" },
                                            { key: "currentStatistic", link: false }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: "ST"
                                },
                                beforeEnter: (to, from, next) => {
                                    if (!to.params.processAnalyticsId && store().getters["reports/getSelectedProcessStatistics"].id) {
                                        store().commit("reports/setSelectedProcessStatistics", {});
                                    }
                                    next();
                                },
                                component: () => import(/* webpackChunkName: "reports" */ "./views/Reports/Reports.vue")
                            }
                        ]
                    },
                    {
                        path: "smartContractList",
                        name: "smartContractContainer",
                        meta: {
                            permissionCode: "SC"
                        },
                        props: {
                            permissionCode: "SC"
                        },
                        beforeEnter: (to, from, next) => {
                            if (to.path !== "/smartContract") {
                                store().commit("smartContractDesigner/setInEditFunction", null);
                                window.localStorage.removeItem("funtionInEdit");
                                window.localStorage.removeItem("contractInEdit");
                            }
                            next();
                        },
                        component: () => import(/* webpackChunkName: "SmartContractContainer" */ "./views/SmartContractContainer/SmartContractContainer.vue"),
                        children: [
                            {
                                path: "/",
                                name: "smartContract",
                                meta: {
                                    permissionCode: "SC"
                                },
                                props: {
                                    permissionCode: "SC"
                                },
                                component: () => import(/* webpackChunkName: "SmartContractList" */ "./views/SmartContractList/SmartContract.vue"),
                                children: [
                                    {
                                        path: "/",
                                        name: "smartContractList",
                                        meta: {
                                            permissionCode: "SC",
                                            breadcrumbs: {
                                                type: "edit",
                                                path: [
                                                    { label: "generic.bcApplications", link: "/applications" },
                                                    { key: "currentAppName", link: false },
                                                    { label: "generic.bcBlockchain", link: "/smartContractList" }
                                                ]
                                            }
                                        },
                                        props: {
                                            permissionCode: "SC"
                                        },
                                        component: () => import(/* webpackChunkName: "SmartContractList" */ "./views/SmartContractList/SmartContractList.vue")
                                    },
                                    {
                                        path: "newSmartContract",
                                        name: "newSmartContract",
                                        meta: {
                                            permissionCode: "SC"
                                        },
                                        props: {
                                            permissionCode: "SC"
                                        },
                                        component: () => import("./views/SmartContractList/NewSmartContract.vue")
                                    },
                                    {
                                        path: "useTemplate",
                                        name: "useTemplate",
                                        meta: {
                                            permissionCode: "SC"
                                        },
                                        props: {
                                            permissionCode: "SC"
                                        },
                                        component: () => import("./views/SmartContractList/UseTemplateSC/UseTemplateSC.vue")
                                    },
                                    {
                                        path: "startFromScratch",
                                        name: "startFromScratch",
                                        meta: {
                                            permissionCode: "SC",
                                            breadcrumbs: {
                                                type: "edit",
                                                path: [
                                                    { label: "generic.bcApplications", link: "/applications" },
                                                    { key: "currentAppName", link: false },
                                                    { label: "generic.bcBlockchain", link: "/smartContractList" }
                                                ]
                                            }
                                        },
                                        props: {
                                            permissionCode: "SC"
                                        },
                                        component: () => import("./views/SmartContractList/StartFromScratch.vue")
                                    }
                                ]
                            },
                            {
                                path: "/smartContract",
                                name: "smartContractDesigner",
                                meta: {
                                    permissionCode: "SC"
                                },
                                props: {
                                    permissionCode: "SC"
                                },
                                // eslint-disable-next-line max-len
                                component: () => import(/* webpackChunkName: "SmartContractDesigner" */ "./views/SmartContractDesigner/SmartContractDesigner.vue")
                            }
                        ]
                    },
                    {
                        path: "settings",
                        component: () => import("@/components/Admin/Application/applications.vue"),
                        meta: {
                            permissionCode: "AS"
                        },
                        children: [
                            {
                                path: "general",
                                name: "highlights",
                                meta: {
                                    permissionCode: { parent: "AS", child: "HL" },
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcSettings", link: false },
                                            { label: "generic.bcGeneral", link: false }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: ["AS", "HL"]
                                },
                                component: () => import("@/components/Admin/Application/AddEditApp/addEditApp.vue")
                            },
                            {
                                path: "appSpecificGroups",
                                name: "appSpecificGroups",
                                meta: {
                                    permissionCode: { parent: "AS", child: "GR" },
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcSettings", link: false },
                                            { label: "generic.bcApplicationSpecificGroups", link: false }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: ["AS", "GR"]
                                },
                                component: () => import("@/components/Admin/Application/AppSpecificGroups/appSpecificGroups.vue")
                            },
                            {
                                path: "workSchedule",
                                name: "appSchedule",
                                meta: {
                                    permissionCode: { parent: "AS", child: "WS" },
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcSettings", link: false },
                                            { label: "generic.bcWorkSchedule", link: false }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: ["AS", "WS"]
                                },
                                component: () => import("@/components/Admin/WorkSchedule/WorkSchedule.vue")
                            },
                            {
                                path: "permissions",
                                name: "permissions",
                                meta: {
                                    permissionCode: { parent: "AS", child: "PE" },
                                    breadcrumbs: {
                                        type: "edit",
                                        path: [
                                            { label: "generic.bcApplications", link: "/applications" },
                                            { key: "currentAppName", link: false },
                                            { label: "generic.bcSettings", link: false },
                                            { label: "generic.bcPermissionsSet", link: false }
                                        ]
                                    }
                                },
                                props: {
                                    permissionCode: ["AS", "PE"]
                                },
                                component: () => import("@/components/Admin/Application/AppPermissions/AppPermissionsContainer.vue")
                            },
                            {
                                path: "",
                                redirect: {
                                    name: "highlights",
                                    meta: {
                                        permissionCode: { parent: "AS", child: "HL" },
                                        breadcrumbs: {
                                            type: "app",
                                            path: [
                                                { label: "asd", link: "xxx" },
                                                { label: "qwe", link: "yyy" }
                                            ]
                                        }
                                    },
                                    props: {
                                        permissionCode: ["AS", "HL"]
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    },

    {
        path: "/administration",
        name: "administration",
        meta: { checkAdmin: true },
        component: () => import(/* webpackChunkName: "admin" */ "./views/Admin/Admin.vue"),
        children: [
            {
                path: "users",
                name: "roles",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                component: () => import("@/components/Admin/RolesAndUsers/RolesUsers.vue")
            },
            {
                path: "workSchedule",
                name: "schedule",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                component: () => import("@/components/Admin/WorkSchedule/WorkSchedule.vue")
            },
            {
                path: "appmanagement",
                name: "appManagement",
                meta: { checkAdmin: true },
                component: () => import("@/components/Admin/AppManagement/AppManagement.vue")
            },
            {
                path: "documentmanagement",
                name: "documentManagement",
                meta: { checkAdmin: true },
                component: () => import("@/components/Admin/DocumentManagement/DocumentManagement.vue")
            },
            {
                path: "uis",
                name: "uis",
                meta: { checkAdmin: true },
                component: () => import("@/components/Admin/UIManagement/UIManagement.vue")
            },
            {
                path: "mktcomponents",
                name: "mktComponents",
                meta: { checkAdmin: true },
                component: () => import("@/components/Admin/MktComponents/MktComponents.vue")
            },
            {
                path: "mktapps",
                name: "mktApps",
                meta: { checkAdmin: true },
                component: () => import("@/components/Admin/MktApps/MktApps.vue")
            },
            {
                path: "settings",
                name: "settings",
                meta: { checkAdmin: true },
                component: () => import("@/components/Admin/Settings/Settings.vue")
            },
            {
                path: "messagingAndComm",
                name: "messagingAndComm",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                component: () => import("@/components/Admin/NotificationSettings/NotificationSettings.vue")
            },
            {
                path: "emailTemplates",
                name: "emailTemplates",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },

                component: () => import("@/components/Admin/TaskNotifications/TaskNotifications.vue")
            },
            {
                path: "features",
                name: "labs",
                meta: { checkAdmin: true },
                component: () => import("@/components/Admin/LabsComponent/LabsComponent.vue"),
                children: [
                    {
                        path: "",
                        name: "FeaturesMainPage",
                        meta: {
                            checkAdmin: true,
                            breadcrumbs: {
                                type: "app",
                                path: [
                                    { label: "generic.bcAdmin", link: false }
                                ]
                            }
                        },
                        component: () => import("@/components/Admin/LabsComponent/FeaturesMainPage.vue")
                    },
                    {
                        path: "featureConfiguration",
                        name: "FeatureDetails",
                        meta: { checkAdmin: true },
                        component: () => import("@/components/Admin/LabsComponent/FeatureDetails.vue"),
                        beforeEnter: (to, from, next) => {
                            if (from.name === "FeaturesMainPage") {
                                next(true);
                            } else {
                                next({ path: "/administration/features" });
                            }
                        }
                    }
                ]
            },
            {
                path: "plugins",
                name: "Plugins",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                component: () => import("@/components/Admin/Plugins/Plugins.vue")
            },
            {
                path: "authentication",
                name: "Authentication",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                // component: () => import("@/components/Admin/Authentication/Authentication.vue")
                component: () => import("@/components/Admin/Authentication/AuthenticationNew.vue")
            },
            {
                path: "systemApis",
                name: "SystemApis",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                component: () => import("@/components/Admin/SystemApis/SystemApis.vue")
            },
            {
                path: "logs",
                name: "logs",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                component: () => import("@/components/Admin/Logs/Logs.vue")
            },
            {
                path: "sslCertificates",
                name: "SSLCertificates",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                component: () => import("@/components/Admin/SSLCertificates/SSLCertificates.vue")
            },
            {
                path: "processController",
                name: "processInspector",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                component: () => import("@/components/Admin/ProcessInspector/ProcessInspector.vue")
            },
            {
                path: "branding",
                name: "branding",
                meta: {
                    checkAdmin: true,
                    breadcrumbs: {
                        type: "app",
                        path: [
                            { label: "generic.bcAdmin", link: false }
                        ]
                    }
                },
                component: () => import("@/components/Admin/BrandingPage/BrandingPage.vue")
            }
        ]
    },

    {
        path: "/tasks/teamsTasks",
        redirect: { path: "/tasks/teamTasks" }
    },
    {
        path: "/tasks",
        name: "tasks",
        redirect: { path: "/tasks/myTasks", query: { tab: "todo" } },
        beforeEnter: (to, from, next) => {
            if (!store().getters["userProfile/getUserId"]) {
                store()
                    .dispatch("tasks/getUserDetails")
                    .then(
                        () => {
                            next(true);
                        },
                        () => {
                            next(true);
                        }
                    );
            } else {
                next(true);
            }
        },
        component: () => import(/* webpackChunkName: "tasks" */ "./views/TaskList/taskList.vue"),
        children: [
            {
                path: "myTasks",
                name: "myOpenTasks",
                props: {
                    type: "myOpenTasks"
                },
                component: () => import(/* webpackChunkName: "tasksContainer" */ "@/components/tasks/appTasksContainer/appTasksContainer.vue")
            },
            {
                path: "teamTasks",
                name: "teamsTasks",
                props: {
                    type: "teamsTasks"
                },
                beforeEnter: (to, from, next) => {
                    const userIsManager = store().getters["userProfile/getUserIsManager"];
                    if (userIsManager) {
                        next();
                    } else {
                        next("/mydashboard");
                    }
                },
                component: () => import(/* webpackChunkName: "tasksContainer" */ "@/components/tasks/appTasksContainer/appTasksContainer.vue")
            },
            {
                path: ":taskId",
                name: "appUserTask",
                alias: [
                    "/mydashboard-tasks/:taskId",
                    "/myteamsdashboard-tasks/:taskId",
                    "/myTasks-todoTasks/:taskId",
                    "/myTasks-completedTasks/:taskId",
                    "/teamTasks-todoTasks/:taskId",
                    "/teamTasks-completedTasks/:taskId"

                ],
                beforeEnter: (to, from, next) => {
                    const [, second] = to.path.split("/");

                    if (["teamTasks-completedTasks", "teamTasks-todoTasks", "myteamsdashboard-tasks"].includes(second)) {
                        const userIsManager = store().getters["userProfile/getUserIsManager"];
                        if (userIsManager) {
                            next();
                        } else {
                            next("/accessDenied");
                        }
                    } else {
                        next();
                    }
                },
                props: true,
                component: () => import(/* webpackChunkName: "appUserTask" */ "@/pages/fabricInterface/appUserTask.vue")
            }
        ]
    },
    {
        path: "/userProfile",
        component: () => import(/* webpackChunkName: "userProfile" */ "./views/UserProfile/userProfile.vue"),
        children: [
            {
                path: "",
                name: "myAccount",
                component: () => import(/* webpackChunkName: "myAccount" */ "@/components/User/myAccount.vue")
            }
        ]
    },

    {
        path: "/task",
        name: "EmailResponseScreens",
        component: () => import("@/components/tasks/emailScreens/EmailResponseScreens.vue")
    },

    {
        path: "/manageGroups",
        name: "manageGroups",
        component: () => import(/* webpackChunkName: "manageGroups" */ "./views/ManageApplicationGroups/manageAppGroups.vue")
    },

    {
        path: "/accessDenied",
        name: "accessDenied",
        alias: ["/taskNotAvailable"],
        component: () => import(/* webpackChunkName: "manageGroups" */ "./views/AccessDenied/AccessDeniedPage.vue")
    },
    {
        path: "/export",
        name: "export",
        component: () => import("../login/views/ExportReports/ExportPage.vue"),
        beforeEnter: (to, from, next) => {
            if (localStorage.getItem("localIsSmallScreen")) {
                next("/");
            } else {
                const { fileName, type } = to.query;
                const initialURLCookie = readCookie("initialURL");
                if (initialURLCookie) {
                    eraseCookie("initialURL");
                }
                store().dispatch("reports/actDownloadExportedFile", { fileName, type })
                    .then(response => {
                        store().commit("reports/setDataToExport", { fileName, response });
                        next(true);
                    })
                    .catch(() => {
                        next({ path: "/accessDenied" });
                    });
            }
        }
    },
    {
        path: "/softwareLicenses",
        name: "SoftwareLicenses",
        component: () => import(/* webpackChunkName: "SoftwareLicenses" */ "./views/SoftwareLicenses/SoftwareLicenses.vue")
    },
    ...process.env.VUE_APP_SOURCEMAPS === "true" ? extraRoutes : [],
    {
        path: "*",
        name: "failover",
        component: Apps
    },
    {
        path: "/:catchAll(.*)",
        name: "pageNotFound",
        props: {
            pageType: "pageNotFound"
        },
        component: () => import(/* webpackChunkName: "AccessDeniedPage" */ "./views/AccessDenied/AccessDeniedPage.vue")
    }
];
